<template>
  <div class="h-100">
    <transition name="fade" mode="out-in">
      <div
        class="h-100 d-flex flex-column column-rounded column-padding bg-white"
        :key="screens[currentScreen].name"
      >
        <p
          v-if="screens[currentScreen].hasOwnProperty('mainHeading')"
          class="text-primary text-center"
        >
          {{ screens[currentScreen].mainHeading }}
        </p>
        <h2
          v-if="screens[currentScreen].hasOwnProperty('formHeading')"
          class="is-h2 text-blue text-center"
        >
          {{ screens[currentScreen].formHeading }}
        </h2>

        <div class="flex-grow-1">
          <component
            v-if="isRadioGroup || isCheckboxGroup"
            v-bind:is="screens[currentScreen].type"
            :formData="screens[currentScreen].formData"
          ></component>
          <component
            v-else-if="isPersonalInfo"
            v-bind:is="screens[currentScreen].type"
            @goBack="goBack()"
            @goForward="canGoForward()"
            :configurationData="getConfigurationData"
            :formData="screens[currentScreen].formData"
            @formSubmitted="formSubmitted()"
          ></component>
          <component
            v-else-if="isConfirmation"
            v-bind:is="screens[currentScreen].type"
            :configurationData="getConfigurationData"
            :personalData="getPersonalData"
            @goBack="goBack()"
            @formSubmitted="formSubmitted()"
          ></component>
          <component
            v-else-if="isSuccess"
            v-bind:is="screens[currentScreen].type"
            :configurationData="getConfigurationData"
            :personalData="getPersonalData"
          ></component>
          <div class="position-relative">
            <div
              v-if="showRequiredError"
              class="validation-error position-absolute d-block"
              style="bottom: 7px"
            >
              Bitte treffen Sie eine Auswahl
            </div>
          </div>
        </div>
        <div v-bind:class="buttonGroupClass">
          <div v-if="screens[currentScreen].hasOwnProperty('backButtonText')">
            <button
              :id="screens[currentScreen].backButtonID"
              @click="goBack()"
              class="btn btn-outline-primary text-uppercase btn-sm-md-down"
            >
              {{ screens[currentScreen].backButtonText }}
            </button>
          </div>
          <div
            v-if="screens[currentScreen].hasOwnProperty('forwardButtonText')"
          >
            <button
              :id="screens[currentScreen].forwardButtonID"
              v-on:click="canGoForward()"
              class="btn btn-primary text-uppercase btn-sm-md-down"
            >
              {{ screens[currentScreen].forwardButtonText }}
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>


<script>
import RadioGroup from "./screens/RadioGroup";
import CheckboxGroup from "./screens/CheckboxGroup";
import Information from "./screens/Information";
import PersonalInfo from "./screens/PersonalInfo";
import Confirmation from "./screens/Confirmation";
import Success from "./screens/Success";
export default {
  name: "konfigurator-main",
  data() {
    return {
      screens: [
        {
          name: "ich_bin",
          forwardButtonID: "01-konfigurieren",
          forwardButtonText: "JETZT KONFIGURIEREN",          
          mainHeading: "Mein persönliches Angebot – Schritt 1",
          formHeading: "Ich bin …",
          type: "radio-group",
          showInConfirmation: true,
          formData: {
            options: [],
            selected: null,
          },
        },
        {
          name: "ich_habe",
          backButtonID: "02-zurueck",
          backButtonText: "ZURÜCK",
          forwardButtonID: "02-weiter",
          forwardButtonText: "WEITER",          
          mainHeading: "Mein persönliches Angebot – Schritt 2",
          formHeading: "Ich habe …",
          type: "radio-group",
          showInConfirmation: true,
          formData: {
            options: [],
            selected: null,
          },
        },
        {
          name: "ich_moechte",
          backButtonID: "03-zurueck",
          backButtonText: "ZURÜCK",
          forwardButtonID: "03-weiter",
          forwardButtonText: "WEITER",
          mainHeading: "Mein persönliches Angebot – Schritt 3",
          formHeading: "Ich möchte …",
          type: "checkbox-group",
          showInConfirmation: true,
          formData: {
            options: [
            ],
            selected: [],
          },
        },
        {
          name: "ihr_optimaler_kurs",
          mainHeading: "Mein persönliches Angebot",
          formHeading: "Ihr optimaler Kurs",
          type: "personal-info",
          formData: {
            anrede: {
              value: "",
              label: "Anrede",
              showInConfirmation: true,
            },
            vorname: {
              value: "",
              label: "Vorname",
              showInConfirmation: true,
            },
            nachname: {
              value: "",
              label: "Nachname",
              showInConfirmation: true,
            },
            email: {
              value: "",
              label: "E-Mail",
              showInConfirmation: true,
            },
            telefon: {
              value: "",
              label: "Telefon",
              showInConfirmation: true,
            },
            terms: {
              value: "",
              label: "Datenschutz",
              showInConfirmation: false,
            },
          },
        },
        // {
        //   name: "zusammenfassung",
        //   mainHeading: "Mein persönliches Angebot",
        //   formHeading: "Zusammenfassung",
        //   type: "confirmation",
        // },
        {
          name: "success",
          mainHeading: "Mein persönliches Angebot",
          formHeading: "Vielen Dank!",
          type: "success",
        },
      ],
      showRequiredError: false,
      currentScreen: 0,

      courseTypeOptions: ["E-Learning Kurs", "Tageslehrgang Kurs"],
    };
  },

  methods: {
    goBack: function () {
      this.currentScreen--;
      this.showRequiredError = false;
    },
    canGoForward: function () {
      if (this.isRadioGroup && !this.radioGroupValid) {
        this.showRequiredError = true;
      } else if (this.isCheckboxGroup && !this.checkboxGroupValid) {
        this.showRequiredError = true;
      } else {
        this.showRequiredError = false;
        this.currentScreen++;
      }
    },
    formSubmitted: function () {
      this.currentScreen++;
    },
  },

  computed: {
    buttonGroupClass: function () {
      return [
        "text-center",
        {
          "justify-content-between d-flex":
            this.screens[this.currentScreen].hasOwnProperty("backButtonText") &&
            this.screens[this.currentScreen].hasOwnProperty(
              "forwardButtonText"
            ),
        },
      ];
    },
    isRadioGroup: function () {
      return this.screens[this.currentScreen].type === "radio-group";
    },
    isCheckboxGroup: function () {
      return this.screens[this.currentScreen].type === "checkbox-group";
    },
    isPersonalInfo: function () {
      return this.screens[this.currentScreen].type === "personal-info";
    },
    isConfirmation: function () {
      return this.screens[this.currentScreen].type === "confirmation";
    },
    isSuccess: function () {
      return this.screens[this.currentScreen].type === "success";
    },
    radioGroupValid: function () {
      return this.screens[this.currentScreen].formData.selected;
    },
    checkboxGroupValid: function () {
      return this.screens[this.currentScreen].formData.selected.length;
    },
    getConfigurationData: function () {
      let dataO = {};
      this.screens.forEach(function (screen) {
        if (screen.type === "radio-group" || screen.type === "checkbox-group") {
          // if(screen.showInConfirmation) {
          let objKey = screen.name;
          dataO[objKey] = {
            label: screen.formHeading,
            value: screen.formData.selected,
            showInConfirmation: screen.showInConfirmation,
          };
          // }
        }
      });
      return dataO;
    },
    getPersonalData: function () {
      let dataO = {};
      this.screens.forEach(function (screen) {
        if (screen.type === "personal-info") {
          for (const [key, value] of Object.entries(screen.formData)) {
            dataO[key] = value;
          }
        }
      });
      return dataO;
    },
  },
  mounted() {
    let _this = this;
    axios
      .get("/api/konfigurator-get-options")
      .then(function(response){
        let optionsData = response.data;
        for (const property in optionsData) {
          let thisScreen = _this.screens.filter(
            (screens) => screens.name === property
          )[0];
          thisScreen.formData.options = optionsData[property];
        }
      });
  },

  components: {
    RadioGroup,
    CheckboxGroup,
    Information,
    PersonalInfo,
    Confirmation,
    Success,
  },
};
</script>